export default "__VITE_ASSET__a7f30985__"